import {
  Calendar,
  Inbox,
  Settings,
  ChartSpline,
  NotepadText,
  Building2,
  Euro,
  Bike,
  Store,
  User as UserIcon,
  Library,
  Waypoints,
  ConciergeBell,
  ClipboardList,
  Shield,
  Presentation,
  Users,
  LayoutGrid,
  Hotel,
  MapPin,
} from 'lucide-react'
import { Permission, Role } from '.'

const reivewItem = {
  title: 'reviews',
  url: '#',
  icon: Inbox,
}

const insightItem = {
  title: 'insights',
  url: '/insights',
  icon: ChartSpline,
  permission: Permission.Reports,
}

const bookingsItem = {
  title: 'bookings',
  url: '/bookings?status=waiting_confirmation',
  icon: NotepadText,
  permission: Permission.BookingsViewAny,
}

const earningsItem = {
  title: 'earnings',
  url: '/earnings',
  icon: Euro,
  permission: Permission.Reports,
}

const shopsItem = {
  title: 'online_stores',
  url: '/online-stores',
  icon: Store,
  permission: Permission.StoresViewAny,
}

const internalExperiencesItem = {
  title: 'internal_experiences',
  url: '/experiences',
  icon: ConciergeBell,
  permission: Permission.ExperiencesViewAny,
}

const externalExperiencesItem = {
  title: 'external_experiences',
  url: '/external-experiences',
  icon: Waypoints,
  permission: Permission.ExternalExperiencesViewAny,
}

const groupExperiencesItem = {
  title: 'group_experiences',
  url: '/group-experiences',
  icon: Hotel,
  permission: Permission.GroupExperiencesViewAny,
}

const calendarItem = {
  title: 'calendar',
  url: '/calendar',
  icon: Calendar,
  permission: Permission.BookingsViewAny,
}

const settings = {
  title: 'settings',
  url: '/settings',
  icon: Settings,
  permission: Permission.SettingsEditBase,
}

const organizerItem = {
  title: 'organizers',
  url: '/companies/organizer',
  icon: Building2,
  permission: Permission.CompaniesViewAny,
}

const sellerItem = {
  title: 'sellers',
  url: '/companies/seller',
  icon: Building2,
  permission: Permission.CompaniesViewAny,
}

const locationsItem = {
  title: 'locations',
  url: '/companies/chain',
  icon: Building2,
  permission: Permission.CompaniesViewAny,
}

const productItem = {
  title: 'products',
  url: '/products',
  icon: Bike,
  permission: Permission.ProductsViewAny,
}

const userItem = {
  title: 'users',
  url: '/users',
  icon: UserIcon,
  permission: Permission.UsersViewAny,
}

const tdlLeadsItem = {
  title: 'TDL Leads',
  url: '/tdl-leads',
  icon: ClipboardList,
  permission: Permission.TdlLeadsViewAny,
}

const rolesItem = {
  title: 'roles_management',
  url: '/roles',
  icon: Shield,
  permission: Permission.RolesViewAny,
}

const salesDemosItem = {
  title: 'Sales Demos',
  url: '/sales-demos',
  icon: Presentation,
  permission: Permission.SalesDemosViewAny,
}

const chainsItem = {
  title: 'chains',
  url: '/chains',
  icon: Library,
  permission: Permission.ChainsViewAny,
}

const categoriesItem = {
  title: 'categories',
  url: '/categories',
  icon: LayoutGrid,
  permission: Permission.CategoriesViewAny,
}

const placesItem = {
  title: 'places',
  url: '/places',
  icon: MapPin,
  permission: Permission.LocationPlacesViewAny,
}

const customersItem = {
  title: 'customers',
  url: '/customers',
  icon: Users,
  // DEV-777 — the Clienti page hosts the reception access-code recovery tab, so
  // it opens for the narrow customers.viewAccessCode (held down to staff) too.
  // Full-CRM roles also hold this permission; the list tab itself stays gated by
  // customers.viewAny inside the page.
  permission: Permission.CustomersViewAccessCode,
}

export const sidebarItems: Record<string, any> = {
  booking: [],
  dashboard: [
    insightItem,
    bookingsItem,
    calendarItem,
    earningsItem,
    customersItem,
  ],
  platform: [
    organizerItem,
    sellerItem,
    locationsItem,
    chainsItem,
    userItem,
    tdlLeadsItem,
    salesDemosItem,
    rolesItem,
  ],
  experiences: [shopsItem, externalExperiencesItem, groupExperiencesItem, internalExperiencesItem, categoriesItem, placesItem],
  resources: [productItem],
  account: [settings],
}
